// extracted by mini-css-extract-plugin
export default {"customToast":"toast_customToast__2YX7F","customToastHeader":"toast_customToastHeader__1uimr"};